module.exports = __webpack_public_path__ + "static/media/BYJU.8d1bf110.webp";